import PAxios from '../../../http/requests/priority-settings-management/index.js';
import Promise from 'lodash/_Promise';

export default {
    openModal ({ commit }, payload) {
        commit('OPEN_MODAL', payload.open);
        commit('SET_MODAL_ERRORS', {})
        if (payload.open && payload.id) {
            PAxios.getSetting(payload.id)
                .then(response => {
                    commit('SET_MODAL_DATA', response.data.data);
                }).catch(error => {
                commit('OPEN_MODAL', false);
            });
        }
    },
    setData ({ commit }, data) {
        commit('SET_MODAL_DATA', data);
    },
    setDisabled ({ commit }, data) {
        let id = data.id;
        let value = !data.disabled;
        return PAxios.setDisabled(id, value);
    },
    loadLogs ({ commit }) {
        return new Promise((resolve, reject) => {
            PAxios.getLogs()
                .then(response => {
                    commit('SET_LOGS_DATA', response.data.data);
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
    getSettings ({ commit }) {
        return new Promise((resolve, reject) => {
            PAxios.getSettings()
                .then(response => {

                    commit('SET_PRIORITY_SETTINGS', response.data.data);
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
    getSettingTypeOptions ({ commit }) {
        return new Promise((resolve, reject) => {
            PAxios.getSettingTypeOptions()
                .then(response => {
                    commit('SET_SETTINGS_TYPE_OPTIONS', response.data.data);
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
    openChangelog ({ commit }, value) {
        commit('SET_OPEN_CHANGELOG', value);
    },
    createSetting ({
        commit,
        state,
    }, payload) {
        let data = JSON.parse(JSON.stringify(payload.setting));
        return new Promise((resolve, reject) => {
            PAxios.createSetting(data)
                .then(response => {
                    commit('SET_MODAL_ERRORS', {});
                    commit('SET_MODAL_DATA', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_MODAL_ERRORS', error.response.data.data);
                    }
                    reject(error);
                });
        });
    },
    updateSetting ({
        commit,
        state,
    }, payload) {
        let data = JSON.parse(JSON.stringify(payload.setting));
        return new Promise((resolve, reject) => {
            PAxios.updateSetting(payload.id, data)
                .then(response => {
                    commit('SET_MODAL_ERRORS', {});
                    commit('SET_MODAL_DATA', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_MODAL_ERRORS', error.response.data.data);
                    }
                    reject(error);
                });
        });
    },
    updateSort({
        commit,
    }, payload) {
        let data = JSON.parse(JSON.stringify({
            data: payload.data,
        }));

        return new Promise((resolve, reject) => {
            PAxios.updateSort(data)
                .then(response => {
                    commit("SET_MODAL_ERRORS", {});
                    commit("SET_PRIORITY_SETTINGS", response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 422) {
                        commit("SET_MODAL_ERRORS", error.response.data.data);
                    }
                    reject(error);
                });
        });
    }
};
